import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=d2705b88&scoped=true"
import script from "./contact-card.vue?vue&type=script&lang=js"
export * from "./contact-card.vue?vue&type=script&lang=js"
import style0 from "../../../assets/commoon/css/common.css?vue&type=style&index=0&id=d2705b88&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2705b88",
  null
  
)

export default component.exports